// Contains default company data for all services.
// These values are spread into each service configuration (in configs),
// but can be manually overridden by redefining the keys in a specific config.

import { COMPANY_COUNTRY_OPTIONS } from '@/helpers/enums';
import { CompanyCountryWording, Company } from '@/types';

export const COMPANIES: Record<string, Company> = {
  SERIAL_SCREENER: {
    COMPANY_NAME: 'Serial Screener',
    COMPANY_COUNTRY: COMPANY_COUNTRY_OPTIONS.FRANCE, // must match key in COMPANY_COUNTRY_WORDING
    COMPANY_ADDRESS:
      '108 rue de Billancourt 92100 Boulogne-Billancourt, France',
    REGISTRATION_NUMBER: '533 225 223',
    UTM_SOURCE: 'Serialscreener',
    CONTACT: 'contact@serialscreener.com',
    TVA: 'FR84 533 225 223',
  },
  DIGITAREN_LIMITED: {
    COMPANY_NAME: 'DIGITAREN LIMITED',
    COMPANY_COUNTRY: COMPANY_COUNTRY_OPTIONS.CYPRUS, // must match key in COMPANY_COUNTRY_WORDING
    COMPANY_ADDRESS:
      'Andrea Panagidi, 30, Flat/Office 3, Paralimni, 5385, Famagusta, Cyprus',
    REGISTRATION_NUMBER: 'HE 464561',
    UTM_SOURCE: 'Digitaren',
    CONTACT: 'contact@dtrn.eu',
    TVA: '60117304P',
  },
  TWENTY_SIX_ADS: {
    COMPANY_NAME: '26ADS DOO',
    COMPANY_COUNTRY: COMPANY_COUNTRY_OPTIONS.BOSNIA, // must match key in COMPANY_COUNTRY_WORDING
    COMPANY_ADDRESS: 'Gavrila Principa 23, 75420 Bratunac, Bosnia-Herzegovina',
    REGISTRATION_NUMBER: 'MB 11258379',
    UTM_SOURCE: '26ads',
  },
} as const satisfies Record<string, Company>;

export const COMPANY_COUNTRY_WORDING: CompanyCountryWording = {
  [COMPANY_COUNTRY_OPTIONS.FRANCE]: {
    EN: 'France',
    LT: 'Prancūzija',
    FR: 'France',
    RS: 'Француска',
    LV: 'Francija',
    EE: 'Prantsusmaa',
    BA: 'Francuska',
    BG: 'Франция',
    FI: 'Ranska',
    PL: 'Francja',
    RO: 'Franța',
    DE: 'Frankreich',
    DK: 'Frankrig',
    SK: 'Francúzsko',
    HR: 'Francuska',
    SE: 'Frankrike',
    SI: 'Francija',
    NO: 'Frankrike',
    CZ: 'Francie',
    CY: 'Γαλλία',
  },
  [COMPANY_COUNTRY_OPTIONS.CYPRUS]: {
    EN: 'Cyprus',
    LT: 'Kipras',
    FR: 'Chypre',
    RS: 'Кипар',
    LV: 'Kipra',
    EE: 'Küpros',
    BA: 'Kipar',
    BG: 'Кипър',
    FI: 'Kypros',
    PL: 'Cypr',
    RO: 'Cipru',
    DE: 'Zypern',
    DK: 'Cypern',
    SK: 'Cyprus',
    HR: 'Cipar',
    SE: 'Cypern',
    SI: 'Ciper',
    NO: 'Kypros',
    CZ: 'Kypr',
    CY: 'Κύπρος',
  },
  [COMPANY_COUNTRY_OPTIONS.BOSNIA]: {
    EN: 'Bosnia and Herzegovina',
    LT: 'Bosnija ir Hercegovina',
    FR: 'Bosnie-Herzégovine',
    RS: 'Босна и Херцеговина',
    LV: 'Bosnija un Hercegovina',
    EE: 'Bosnia ja Hertsegoviina',
    BA: 'Bosna i Hercegovina',
    BG: 'Босна и Херцеговина',
    FI: 'Bosnia ja Hertsegovina',
    PL: 'Bośnia i Hercegowina',
    RO: 'Bosnia și Herțegovina',
    DE: 'Bosnien und Herzegowina',
    DK: 'Bosnien-Hercegovina',
    SK: 'Bosna a Hercegovina',
    HR: 'Bosna i Hercegovina',
    SE: 'Bosnien och Hercegovina',
    SI: 'Bosna in Hercegovina',
    NO: 'Bosnia-Hercegovina',
    CZ: 'Bosna a Hercegovina',
    CY: 'Βοσνία και Ερζεγοβίνη',
  },
  [COMPANY_COUNTRY_OPTIONS.ERROR]: {
    EN: 'Error',
    LT: 'Error',
    FR: 'Error',
    RS: 'Error',
    LV: 'Error',
    EE: 'Error',
    BA: 'Error',
    BG: 'Error',
    FI: 'Error',
    PL: 'Error',
    RO: 'Error',
    DE: 'Error',
    DK: 'Error',
    SK: 'Error',
    HR: 'Error',
    SE: 'Error',
    SI: 'Error',
    NO: 'Error',
    CZ: 'Error',
    CY: 'Error',
  },
};
